// extracted by mini-css-extract-plugin
module.exports = {"container":"Projects_container__bhKtF","heading":"Projects_heading__11dNK","aligner":"Projects_aligner__2whVA"};